import {  Edit, Trash2 } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import { useCheckUserPermission } from "../../common/userPermission";

import HeaderModule from "../../components/Header/HeaderModule";

const customFieldsMasterDelete = "customFieldsMasterDelete";

const CustomFieldsMasterList = () => {
  const user_data = useSelector((state) => state.user_data);

  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // showLoadingAlert(); // Show loader while deleting
        handleDelete(id);
      }
    });
  };

  // const showLoadingAlert = () => {
  //   MySwal.fire({
  //     title: "Deleting...",
  //     text: "Please wait while we process your request.",
  //     allowOutsideClick: false,
  //     didOpen: () => {
  //       MySwal.showLoading(); // Show loading spinner
  //     },
  //   });
  // };

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "customFieldsMaster",
    };

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your custom fields has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
      size : 120
    },
    {
      header: "Business Name",
      accessorKey: "businessName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Label",
      accessorKey: "label",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Value",
      accessorKey: "value",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size : 360,
      Cell: ({ row }) => (
        <span>
          {row.original.value.length > 100
            ? `${row.original.value.substring(0, 100)}...`
            : row.original.value}
        </span>
      ),
    },
    {
      header: "Active",
      accessorKey: "isActive",
      enableSorting: true,
      sortingFn: "numeric",
      Cell: ({ row }) => (
        <span
          className={
            row.original.isActive ? "btn btn-primary btn-sm me-2" : "btn btn-outline-primary btn-sm me-2"
          }
        >
          {row.original.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          {useCheckUserPermission(route.customFieldsMaster) && (
            <button
            className="btn btn-outline-primary btn-sm me-2" 
              // color="primary"
              onClick={() => {
                navigate(`${route.customFieldsMaster}/${row.original.ID}`);
                console.log("Edit row:", row.original.ID);
              }}
            >
              <Edit className='custome-icon-size' />
            </button>
          )}
          {useCheckUserPermission(customFieldsMasterDelete) && (
            <button
            className="btn btn-outline-primary btn-sm me-2" 
              // color="error"
              onClick={() => {
                showConfirmationAlert(row.original.ID);
                // handleDelete(row.original.ID);
              }}
            >
              <Trash2 className='custome-icon-size' />
            </button>
          )}
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/customFieldsMaster?businessId=${
        user_data?.businessId || 0
      }`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    BusinessName: item?.businessName,
    ID: item?.ID,
    Label: item?.label,
    Value: item?.value,
    Active: item?.isActive === 1 ? "Active" : "Inactive",
  }));

  return (
    <div className="page-wrapper">
      <div className="content">
        <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
          addMasterPageLink={route.customFieldsMaster}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomFieldsMasterList;
